export default __webpack_public_path__ + "static/media/bigDoll.ce87750b.png";